module.exports = __webpack_public_path__ + "media/SAF-300_Ares_WhatsInItForYou_2025.e9952bf3.mp4";